import PayNow from './PayNow';

export default PayNow;
